export const EVENT_DESTINY_GAME_START = "EVENT_DESTINY_GAME_START";
export const EVENT_DESTINY_EXIT_GAME = "EVENT_DESTINY_EXIT_GAME";
export const EVENT_DESTINY_HEARTBEAT = "EVENT_DESTINY_HEARTBEAT";
